<template>
    <div class="three-factors-box">
        <div class="factors-wrapper" v-for="(item, index) in selectItemList" :key="index">
            <div class="factors-header">
                <div class="factors-title">{{ item.title }}</div>
                <span class="base-button" @click="onEdit(item)" v-if="isEdit">选择</span>
            </div>
            <div class="factors-list">
                <div class="factors-item" v-for="(IT, I) in item.list" :key="I">
                    {{ IT || '' }}
                </div>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '65%' }" closeable>
            <div class="factors-popup">
                <div class="popup-title van-hairline--bottom">
                    选择{{ selectItemList[type - 1].title }}
                </div>
                <div class="popup-content">
                    <div class="popup-content-left van-hairline--right">
                        <div class="left-item" v-for="(item, index) in nowThreeFactorsList" :key="index"
                            :class="selectObj[type].includes(item.questionKewWord) ? 'left-item-disabled' : ''"
                            @click="onPopupSelect(item)">
                            {{ item.questionKewWord }}
                        </div>
                    </div>
                    <div class="popup-content-right">
                        <div class="factors-list">
                            <div class="factors-item" v-for="(item, index) in selectObj[type]" :key="item.key">
                                {{ item }}
                                <van-icon name="cross" class="close-box" @click.stop="onPopupRemove(index)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="popup-bottom">
                    <van-button @click.stop="onCancel" native-type="button" class="button-box">取消</van-button>
                    <van-button type="info" @click.stop="onConfirm" native-type="button" class="button-box" :disabled="selectObj[type].length===0">确定</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'selectThreeFactors',
    props: {
        factorsOne: {
            type: Array,
            default: () => ([])
        },
        factorsTwo: {
            type: Array,
            default: () => ([])
        },
        factorsThree: {
            type: Array,
            default: () => ([])
        },
        isEdit: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            type: 1,
            show: false,
            selectObj: {
                1: [],
                2: [],
                3: [],
            },
        }
    },
    computed: {
        ...mapGetters({
            threeFactorsList: 'getThreeFactorsList',
            threeFactorsIndependent: 'getThreeFactorsIndependent'
        }),
        nowThreeFactorsList() {
            let result = []
            if (this.type === 3) {
                result = this.threeFactorsIndependent.factorsThree
            } else if (this.type === 2) {
                result = this.threeFactorsIndependent.factorsTwo
            } else {
                result = this.threeFactorsIndependent.factorsOne
            }
            return [...result, { questionKewWord: '暂无以上症状' }]
        },
        selectFactorsOne: {
            get() {
                return this.factorsOne
            },
            set(value) {
                this.$emit("update:factorsOne", value);
            }
        },
        selectFactorsTwo: {
            get() {
                return this.factorsTwo
            },
            set(value) {
                this.$emit("update:factorsTwo", value);
            }
        },
        selectFactorsThree: {
            get() {
                return this.factorsThree
            },
            set(value) {
                this.$emit("update:factorsThree", value);
            }
        },
        selectItemList() {
            return [
                { title: '隆', type: 1, list: this.selectFactorsOne },
                { title: '赤巴', type: 2, list: this.selectFactorsTwo },
                { title: '培根', type: 3, list: this.selectFactorsThree },
            ]
        }
    },
    methods: {
        onEdit(item) {
            this.type = item.type
            this.selectObj[this.type] = [...item.list]
            this.show = true
        },
        onConfirm() {
            if (this.type === 3) {
                this.selectFactorsThree = [...this.selectObj[this.type]]
            } else if (this.type === 2) {
                this.selectFactorsTwo = [...this.selectObj[this.type]]
            } else {
                this.selectFactorsOne = [...this.selectObj[this.type]]
            }
            this.show = false
        },
        onCancel() {
            this.show = false
        },
        onPopupRemove(index) {
            this.selectObj[this.type].splice(index, 1)
        },
        onPopupSelect(item) {
            if (this.selectObj[this.type].includes(item.questionKewWord)) return
            if (item.questionKewWord === '暂无以上症状' || this.selectObj[this.type].length === 1 && this.selectObj[this.type][0] === '暂无以上症状') {
                return this.selectObj[this.type] = [item.questionKewWord]
            }
            this.selectObj[this.type] = [...this.selectObj[this.type], item.questionKewWord]
        }
    },
}
</script>
<style lang="scss" scoped>
.factors-list {
    display: flex;
    flex-wrap: wrap;

    .factors-item {
        padding: 4px 9px;
        background: #eff3fb;
        border: 1px solid #0082ef;
        color: #0082ef;
        border-radius: 4px;
        margin-right: 10px;
        margin-top: 10px;
    }

    .factors-item-active {
        background: #efffdf;
        border: 1px solid #5ec326;
        color: #5ec326;
    }
}

.three-factors-box {
    line-height: normal;
    width: 100%;

    .factors-wrapper {
        &+.factors-wrapper {
            margin-top: 15px;
        }

        .factors-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 0;

            .factors-title {
                font-weight: bold;
            }

            .base-button {
                background: #0082ef;
                border-radius: 4px;
                padding: 5px 18px;
                color: #fff;
                cursor: pointer;
            }
        }


    }
}

.factors-popup {
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-title {
        padding: 25px 15px;
        font-size: 19px;
        color: #333;
        font-weight: bold;
    }

    .popup-info {
        padding: 25px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .popup-info-length {
            color: #0082ef;
            font-weight: bold;
        }

        .popup-info-title {
            display: flex;
            align-items: center;
        }

        .popup-info-item {
            margin: 0;
        }
    }

    .popup-content {
        flex: 1;
        overflow: hidden;
        display: flex;
        width: 100%;

        .popup-content-left {
            height: 100%;
            overflow-y: auto;
            width: 120px;

            .left-item {
                padding: 10px 0;
                text-align: center;
                cursor: pointer;
                margin-top: 5px;
                background: #f5f5f5;

                &:not(.left-item-disabled):hover {
                    background: #eff3fb;
                    color: #0082ef;
                }
            }

            .left-item-disabled {
                background: #eff3fb;
                color: #a8abb2;
                cursor: not-allowed;
            }

        }

        .popup-content-right {
            height: 100%;
            overflow-y: auto;
            padding: 10px;
            flex: 1;
        }
    }

    .popup-bottom {
        height: 84px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 16px 25px;
        display: flex;

        .button-box {
            font-size: 18px;
            border: none;
            border-radius: 8px;
            flex: 1.5;

            &:nth-child(1) {
                flex: 1;
                background: #e6f0fa;
                margin-right: 30px;
                color: #1989fa;
            }
        }
    }
}
</style>